import { combineReducers } from "redux";

import { leaveDetails } from "./reducer.leave"
const leaveReducers = combineReducers({

    leaveDetails

})
export default leaveReducers;
